import React from "react";
import { Box, CircularProgress } from "@material-ui/core";

class LogoLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
    this.handleLoad = this.handleLoad.bind(this);
  }

  handleLoad() {
    this.setState({ loaded: true });
  }

  render() {
    const {
      logo,
      maxWidth = 600,
      maxHeight = 785,
      containerWidth = 600,
      containerHeight = 785,
      isMini = false,
      style = {},
    } = this.props;
    const { loaded } = this.state;

    // Always set both maxWidth and maxHeight for aspect ratio
    const imageStyle = {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "auto",
      height: "auto",
      objectFit: "contain",
      display: loaded ? "block" : "none",
    };

    const containerStyle = {
      width: containerWidth,
      height: containerHeight,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    };

    return (
      <React.Fragment>
        <Box
          {...containerStyle}
          display="flex"
          alignItems={isMini ? "flex-end" : "center"}
          justifyContent="center"
          overflow="hidden"
          marginBottom={isMini ? "-5px" : "-15px"}
          style={style}
        >
          {!loaded && (
            <Box
              width="100%"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <CircularProgress />
            </Box>
          )}

          <img
            src={logo}
            alt="logo"
            style={imageStyle}
            onLoad={this.handleLoad}
          />
        </Box>
      </React.Fragment>
    );
  }
}

export default LogoLoader;
